import { render, staticRenderFns } from "./FeedTags_Button_Popular.vue?vue&type=template&id=3111fd83&scoped=true&"
import script from "./FeedTags_Button_Popular.vue?vue&type=script&lang=js&"
export * from "./FeedTags_Button_Popular.vue?vue&type=script&lang=js&"
import style0 from "./FeedTags_Button_Popular.vue?vue&type=style&index=0&id=3111fd83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3111fd83",
  null
  
)

export default component.exports